module.exports = __webpack_public_path__ + "img/omani_rial.08081bf2.svg";